import React, { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PageTitle from "../../page-title";
import { Card } from "@ebsco-ui/ebsco-ui";
import withPersonalization from "../../with-personalization";
import "./data-retention-page.scss";
import {
  fetchConsentDateTime,
  getConsentDateTime
} from "../../../store/consent-date";

const DataRetentionPageWithFlagOn = ({
  displayAccountDataInfo,
  displayDataRetentionPageTitle,
  isCoppa,
  consentDate,
  error,
  fetchConsentDateTime
}) => {
  useEffect(() => {
    if (consentDate === null && error === null && !isCoppa) {
      fetchConsentDateTime();
    }
  }, [fetchConsentDateTime, consentDate, error, isCoppa]);
  return (
    <>
      <PageTitle className="data-retention-page__title">
        {displayDataRetentionPageTitle()}
      </PageTitle>
      <Card
        className="data-retention-page__card"
        border="all"
        isRaised={true}
        isRounded={true}
        isTransparent={false}
      >
        {displayAccountDataInfo()}
      </Card>
    </>
  );
};

DataRetentionPageWithFlagOn.propTypes = {
  displayAccountDataInfo: PropTypes.func.isRequired,
  displayDataRetentionPageTitle: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  consentDate: getConsentDateTime(state),
  error: state.consentDateTime.error
});

const mapDispatchToProps = {
  fetchConsentDateTime: fetchConsentDateTime
};

export { DataRetentionPageWithFlagOn };
export default compose(
  withPersonalization,
  connect(mapStateToProps, mapDispatchToProps)
)(DataRetentionPageWithFlagOn);
